const SnipperLoader = () => (
  <>
    <style>
      {`
        .snipper-loader {
          width: 40px;
          height: 40px;
          border: 6px solid #e41f07;
          border-top: 4px solid #fff;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}
    </style>

    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "40px",
      }}
    >
      <div className="snipper-loader" />
    </div>
  </>
);

export default SnipperLoader;
